import axios from "axios";
import { HOST } from "../../setting";

export const service = () => axios.get(`${HOST}/master/kit-list/`);
